module.exports = __webpack_public_path__ + "static/faq_hero-cd9b2a23d6fab8dcb286a73607fb1779.png";